export type NavLinkItem = {
  path: string;
  label: string;
};

type UserRole = 'BUYER' | 'SELLER' | 'ADMIN';

export function getNavLinks(role?: UserRole | null): NavLinkItem[] {
  if (!role) {
    return [
      { path: '/', label: 'Inicio' },
      { path: '/auctions', label: 'Subastas' },
      { path: '/requests/create', label: 'Pedir entradas' },
    ];
  }

  switch (role) {
    case 'SELLER':
      return [
        { path: '/dashboard', label: 'Panel' },
        { path: '/seller/inventory', label: 'Publicar' },
        { path: '/seller/requests', label: 'Solicitudes' },
        { path: '/auctions', label: 'Subastas' },
      ];
    case 'ADMIN':
      return [
        { path: '/admin/dashboard', label: 'Panel' },
        { path: '/admin/matches', label: 'Partidos' },
        { path: '/admin/sellers', label: 'Vendedores' },
        { path: '/auctions', label: 'Subastas' },
      ];
    default:
      return [
        { path: '/auctions', label: 'Subastas' },
        { path: '/requests/create', label: 'Pedir entradas' },
        { path: '/matches', label: 'Partidos' },
        { path: '/account', label: 'Mi cuenta' },
      ];
  }
}
